export const Back = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 10.668C9.114 10.668 10 9.78064 10 8.66797C10 7.5553 9.114 6.66797 8 6.66797C6.886 6.66797 6 7.5553 6 8.66797C6 9.78064 6.886 10.668 8 10.668Z"
        fill="#2B3674"
      />
      <path
        d="M13.878 7.45603C13.7209 6.68827 13.4139 5.95902 12.9747 5.31003C12.5431 4.67155 11.9931 4.12165 11.3547 3.69003C10.7056 3.25092 9.97638 2.94396 9.20867 2.7867C8.8054 2.70492 8.39481 2.66471 7.98333 2.6667V1.33203L5.33333 3.33203L7.98333 5.33203V4.00003C8.306 3.9987 8.62867 4.02936 8.94 4.09336C9.53668 4.21564 10.1035 4.45417 10.608 4.79536C11.1056 5.13086 11.5338 5.55911 11.8693 6.0567C12.3902 6.82685 12.668 7.7356 12.6667 8.66536C12.6666 9.28929 12.5419 9.90691 12.3 10.482C12.1824 10.7591 12.0386 11.0243 11.8707 11.274C11.7021 11.5223 11.5106 11.7542 11.2987 11.9667C10.6533 12.6108 9.83407 13.0527 8.94133 13.238C8.32048 13.3634 7.68085 13.3634 7.06 13.238C6.46304 13.1156 5.89603 12.8769 5.39133 12.5354C4.89432 12.2002 4.46653 11.7724 4.13133 11.2754C3.61104 10.5044 3.33314 9.59547 3.33333 8.66536H2C2.00071 9.86116 2.35792 11.0296 3.026 12.0214C3.4579 12.6588 4.00724 13.2081 4.64467 13.64C5.63508 14.3103 6.80407 14.6676 8 14.6654C8.40618 14.6653 8.81133 14.6245 9.20933 14.5434C9.97649 14.385 10.7053 14.0781 11.3547 13.64C11.6735 13.4252 11.9707 13.1798 12.242 12.9074C12.5137 12.6349 12.7592 12.3376 12.9753 12.0194C13.6451 11.0292 14.0021 9.86075 14 8.66536C14 8.25918 13.9591 7.85404 13.878 7.45603Z"
        fill="#2B3674"
      />
    </svg>
  );
};
